import * as fields from './fields';
import * as resources from './resources';

// Helper
import { ChartType, allChartTypesWithAreaSpline } from './common/chart-types';

export const config = {
    pageTitle: 'Landing Page Performance',
    dateDimension: fields.SALES_DATE_DATETIME,
    filters: {
        status: {
            isEnableDatePicker: true,
            isEnableProductSelect: true,
            isEnableMetrics: true,
        },
    },
    resources: [
        resources.REPORT_MCS_LANDING,
        resources.REPORT_MCS_LANDING_PATH_REFERRER,
        resources.REPORT_MCS_LANDING_PATH_REGION,
    ],
    chart: {
        chartType: ChartType.AreaSpline,
        allowedChartTypes: allChartTypesWithAreaSpline,
        chartId: 'landing-page-performance',
        allYMetrics: [
            fields.VISITS,
            fields.BOUNCES,
            fields.BOUNCE_RATE,
            fields.ASSISTS,
            fields.ASSISTS_RATE,
            fields.AVG_DELTA,
            fields.FM_SALES,
            fields.FM_CVR,
            fields.FM_REVENUE,
            fields.FM_AOV,
            fields.COST,
            fields.FM_CPA,
            fields.FM_ROI,
            fields.FM_ROAS,
        ],
        initialYMetrics: [fields.FM_SALES],
    },
    table: {
        tabListItems: [
            {
                tabName: 'overview',
                displayName: 'Overview',
                isSelected: true,
                metrics: [fields.VISITS, fields.FM_SALES, fields.FM_REVENUE, fields.FM_AOV],
            },
            {
                tabName: 'traffic',
                displayName: 'Traffic',
                metrics: [
                    fields.VISITS,
                    fields.ASSISTS,
                    fields.ASSISTS_RATE,
                    fields.AVG_DELTA,
                    fields.BOUNCES,
                    fields.BOUNCE_RATE,
                ],
            },
            {
                tabName: 'conversion_rates',
                displayName: 'Conversion Rates',
                metrics: [fields.VISITS, fields.FM_SALES, fields.FM_CVR],
            },
            {
                tabName: 'cost',
                displayName: 'Cost Analysis',
                metrics: [fields.FM_REVENUE, fields.COST, fields.FM_CPA, fields.FM_ROI, fields.FM_ROAS],
            },
            {
                tabName: 'all',
                displayName: 'All',
                metrics: [
                    fields.VISITS,
                    fields.ASSISTS,
                    fields.ASSISTS_RATE,
                    fields.AVG_DELTA,
                    fields.BOUNCES,
                    fields.BOUNCE_RATE,
                    fields.FM_SALES,
                    fields.FM_CVR,
                    fields.FM_REVENUE,
                    fields.FM_AOV,
                    fields.COST,
                    fields.FM_CPA,
                    fields.FM_ROI,
                    fields.FM_ROAS,
                ],
            },
        ],
        fieldDataOverrides: {
            referer: [
                {
                    property: 'subchannels',
                    condition: function (subchannels) {
                        return Array.isArray(subchannels) ? subchannels.length > 1 : false;
                    },
                    field: fields.SUBCHANNEL,
                },
            ],
        },
        fieldParentOverrides: {},
        fieldChildren: {
            [fields.REFERER.id]: {
                default: [
                    {
                        useCurrent: true,
                        resource: resources.REPORT_MCS_LANDING,
                        field: fields.LANDING_PATH_HOST,
                    },
                ],
            },
            [fields.SUBCHANNEL.id]: {
                default: [
                    {
                        useCurrent: true,
                        resource: resources.REPORT_MCS_LANDING,
                        field: fields.LANDING_PATH_HOST,
                    },
                ],
            },
            [fields.LANDING_PATH_HOST.id]: {
                default: [
                    {
                        resource: resources.REPORT_MCS_LANDING_PATH_REFERRER,
                        field: fields.LANDING_PATH_PATH,
                    },
                ],
            },
            [fields.LANDING_PATH_PATH.id]: {
                default: [
                    {
                        resource: resources.REPORT_MCS_LANDING_PATH_REFERRER,
                        field: fields.REFERRER_DOMAIN,
                    },
                ],
            },
            [fields.REFERRER_DOMAIN.id]: {
                default: [
                    {
                        useCurrent: true,
                        resource: resources.REPORT_MCS_LANDING_PATH_REFERRER,
                        field: fields.REFERRER_PATH,
                    },
                ],
            },
            [fields.MCS_CONTINENT_NAME.id]: {
                default: [
                    {
                        resource: resources.REPORT_MCS_LANDING_PATH_REGION,
                        field: fields.MCS_COUNTRY_NAME,
                    },
                ],
            },
            [fields.MCS_COUNTRY_NAME.id]: {
                default: [
                    {
                        resource: resources.REPORT_MCS_LANDING_PATH_REGION,
                        field: fields.MCS_CITY_NAME,
                    },
                ],
            },
            [fields.MCS_CITY_NAME.id]: {
                default: [
                    {
                        resource: resources.REPORT_MCS_LANDING_PATH_REGION,
                        field: fields.REFERER,
                    },
                ],
            },
            [fields.LANDING_PATH_GEOGRAPHY.id]: {
                default: [
                    {
                        resource: resources.REPORT_MCS_LANDING_PATH_REFERRER,
                        field: fields.LANDING_PATH_LANGUAGE,
                    },
                ],
            },
            [fields.LANDING_PATH_MARKET.id]: {
                default: [
                    {
                        resource: resources.REPORT_MCS_LANDING_PATH_REFERRER,
                        field: fields.LANDING_PATH_LANGUAGE,
                    },
                ],
            },
            [fields.LANDING_PATH_MARKET.id]: {
                default: [
                    {
                        resource: resources.REPORT_MCS_LANDING,
                        field: fields.LANDING_PATH_LANGUAGE,
                    },
                ],
            },
            [fields.LANDING_PATH_LANGUAGE.id]: {
                default: [
                    {
                        resource: resources.REPORT_MCS_LANDING_PATH_REFERRER,
                        field: fields.LANDING_PATH_CATEGORY,
                    },
                ],
            },
            [fields.LANDING_PATH_CONTENT_TYPE.id]: {
                default: [
                    {
                        resource: resources.REPORT_MCS_LANDING_PATH_REFERRER,
                        field: fields.LANDING_PATH_CONTENT_LENGTH,
                    },
                ],
            },
            [fields.LANDING_PATH_CATEGORY.id]: {
                default: [
                    {
                        resource: resources.REPORT_MCS_LANDING_PATH_REFERRER,
                        field: fields.LANDING_PATH_CONTENT_TYPE,
                    },
                ],
            },
            [fields.LANDING_PATH_CONTENT_LENGTH.id]: {
                default: [
                    {
                        resource: resources.REPORT_MCS_LANDING_PATH_REFERRER,
                        field: fields.LANDING_PATH_CATEGORY,
                    },
                ],
            },
            [fields.LANDING_PATH_TOPIC.id]: {
                default: [
                    {
                        resource: resources.REPORT_MCS_LANDING_PATH_REFERRER,
                        field: fields.LANDING_PATH_CATEGORY,
                    },
                ],
            },
        },
    },
    pagination: {
        currentPage: 1,
        currentRange: [1, 25],
        minPage: 1,
        maxPage: 100,
        totalResults: 12345,
        maxButtons: 10,
        rowDefault: 25,
        rowOptions: [{ value: 10 }, { value: 25 }, { value: 50 }, { value: 100 }, { value: 200 }, { value: 500 }],
    },
};
